import React from 'react';

const LenderSupport = ({ onNext }) => { 
  const [clickedButton, setClickedButton] = React.useState(null);
  const handleClick = (e) => {
    const buttonValue = e.target.value;
    setClickedButton(buttonValue);
    onNext(buttonValue);
  }
  return (
  <>
    <div className="qs-card__head">
      <h2 className="qs-card__title">
        Support from lender offered?
      </h2>
    </div>
    <div className="qs-card__body">
      <p className="qs-card__sub">
        Did the lender offer support or alternatives when you showed signs of financial difficulty? (e.g. missed payments, minimum payments)
      </p>
      <div className="qs-actions">
        <button 
        type="button" 
        value={421}
        className={`qs-btn qs-btn--optn ${clickedButton == '421' ? 'btn-active' : ''}`} 
        onClick={handleClick}>
          Yes
        </button>
        <button 
        type="button" 
        value={422}
        className={`qs-btn qs-btn--optn  ${clickedButton == '422' ? 'btn-active' : ''}`} 
        onClick={handleClick}>
          No
        </button>
      </div>
    </div>
  </>
);
};
export default LenderSupport;
